<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g>
      <path
        d="M11.333,13.335H2a.667.667,0,0,1-.666-.666v-6.4A2.681,2.681,0,0,1,0,4a.392.392,0,0,1,.046-.12,1.04,1.04,0,0,1,0-.127L1.38.422A.664.664,0,0,1,2,0h9.333l.048,0A.663.663,0,0,1,12,.422l1.334,3.333a1.036,1.036,0,0,1,0,.127.4.4,0,0,1,0,.12A2.676,2.676,0,0,1,12,6.295v6.374A.667.667,0,0,1,11.333,13.335ZM5.333,8H8a.668.668,0,0,1,.667.667V12h2V6.669a2.668,2.668,0,0,1-2-.921,2.666,2.666,0,0,1-4,0,2.665,2.665,0,0,1-2,.921V12h2V8.668A.668.668,0,0,1,5.333,8ZM6,9.335V12H7.334V9.335H6Zm-3.547-8h0L1.334,4.1A1.328,1.328,0,0,0,2.664,5.386h.052A1.334,1.334,0,0,0,4,4,.666.666,0,1,1,5.333,4,1.333,1.333,0,0,0,8,4,.667.667,0,1,1,9.333,4,1.335,1.335,0,0,0,12,4.1L10.88,1.335H2.453Z"
        transform="translate(1.333 1.332)"
        fill="#7b8190"
        stroke-width="0"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconStore',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>